//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { envConfig } from '@/js/constants';
import PaginationVue from '@/components/PaginationVue.vue';
export default {
  name: 'LogAwsExportComponent',
  components: {
    PaginationVue: PaginationVue
  },
  props: {
    logItems: {
      type: Array,
      required: true
    },
    logHeaders: {
      type: Array,
      required: true
    },
    getDateAndHours: {
      type: Function,
      required: true
    },
    getUseCaseStatus: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      keyTable2: 0,
      pagination: {
        attributes: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0,
          sort_desc: [true],
          sort_by: ['creation_date']
        }
      }
    };
  }
};